module.exports = __webpack_public_path__ + "static/media/бу.4e9ebe43.mp3";